import { render, staticRenderFns } from "./ClientesPorcentagemFaturamento.vue?vue&type=template&id=09c14154&scoped=true&"
import script from "./ClientesPorcentagemFaturamento.vue?vue&type=script&lang=js&"
export * from "./ClientesPorcentagemFaturamento.vue?vue&type=script&lang=js&"
import style0 from "./ClientesPorcentagemFaturamento.vue?vue&type=style&index=0&id=09c14154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c14154",
  null
  
)

export default component.exports